import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initHintsSection(section) {
  if (section.dataset.wvAnimInited === "1") return;
  section.dataset.wvAnimInited = "1";

  const title = section.querySelector("h2.global_title");
  const content = section.querySelector(".hints-content");
  const items = gsap.utils.toArray(section.querySelectorAll(".hint-item"));

  // elements inside items
  const nums = items.map((it) => it.querySelector(".hint-position")).filter(Boolean);
  const texts = items.map((it) => it.querySelector(".hint-item-desc")).filter(Boolean);

  // --- initial states ---
  if (title) gsap.set(title, { autoAlpha: 0, y: 40 });

  if (content) {
    gsap.set(content, { backgroundPosition: "center center", backgroundSize: "10%" });
  }

  // items base
  gsap.set(items, { autoAlpha: 0, y: 24 });
  gsap.set(nums, { autoAlpha: 0, y: 10, scale: 0.85 });
  gsap.set(texts, { autoAlpha: 0, y: 12 });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 65%",
      once: true,
    },
    defaults: { ease: "power3.out" },
  });

  // Title
  if (title) {
    tl.to(title, { autoAlpha: 1, y: 0, duration: 0.85 }, 0);
  }

  // Center image "scale"
  if (content) {
    tl.to(
      content,
      {
        backgroundSize: "60%",
        duration: 1.2,
        ease: "power4.out",
      },
      0.15
    );
  }

  // Items appear one-by-one
  items.forEach((item, i) => {
    const num = item.querySelector(".hint-position");
    const text = item.querySelector(".hint-item-desc");

    // сам контейнер (чуть-чуть)
    tl.to(
      item,
      { autoAlpha: 1, y: 0, duration: 0.55, ease: "power2.out" },
      0.35 + i * 0.22
    );

    // цифра
    if (num) {
      tl.to(
        num,
        { autoAlpha: 1, y: 0, scale: 1, duration: 0.45, ease: "power3.out" },
        0.38 + i * 0.22
      );
    }

    // текст — почти сразу за цифрой
    if (text) {
      tl.to(
        text,
        { autoAlpha: 1, y: 0, duration: 0.55, ease: "power3.out" },
        0.45 + i * 0.22
      );
    }
  });
}

function initAllHints() {
  document
    .querySelectorAll(".wp-block-blocks-webvibe-block-hints")
    .forEach(initHintsSection);

  ScrollTrigger.refresh();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAllHints);
} else {
  initAllHints();
}